import { negate } from 'lodash/fp';

// Decorators
import ElementDropTarget from '../../../element/dnd/elementDropTargets/ElementDropTarget';

// Utils
import { getTrashIdSafely, isLocationTrash } from '../../../../common/elements/utils/elementLocationUtils';

// Constants
import { BoardSections } from '../../../../common/boards/boardConstants';
import { DROP_TARGET_TYPES } from '../../../../common/elements/elementConstants';

const trashDropTargetHandler = (props, monitor) => {
    props.deselectAllElements();

    const item = monitor.getItem();

    const { draggedElementIds } = item;

    return {
        acceptedElementIds: draggedElementIds,
        location: {
            parentId: getTrashIdSafely(props.currentBoardId),
            section: BoardSections.TRASH,
            position: {
                addedDate: new Date().getTime(),
            },
        },
    };
};

const canDropHandler = (props, monitor) => {
    const { draggedElements } = monitor.getItem();
    return draggedElements.some(negate(isLocationTrash));
};

export default ElementDropTarget({
    drop: trashDropTargetHandler,
    canDrop: canDropHandler,
    hoverType: DROP_TARGET_TYPES.TRASH,
});
